import { ValidationProvider, extend, setInteractionMode } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

function RegisterExtensions () {
  extend('required', {
    ...required,
    message: 'Dit veld is verplicht'
  })

  extend('email', {
    ...email,
    message: 'Dit is geen geldig E-mailadres'
  })

  extend('is_true', {
    validate: value => value === true,
    message: 'Dit veld is verplicht'
  })

  extend('iban', {
    validate: value => {
      return /^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/.test(value)
    },
    message: 'Dit is geen geldige IBAN'
  })
  extend('mobilephone', {
    validate: value => {
      return /06\d{8}/.test(value)
    },
    message: 'Dit is geen geldig telefoonnummer'
  })
  extend('zipcode', {
    validate: value => {
      return /\d{4} ?(?!SS|SA|SD)[A-Z]{2}/i.test(value)
    },
    message: 'Dit is geen geldige postcode'
  })
  extend('phone',
    {
      validate: value => {
        return /[0-9]{10}/.test(value)
      },
      message: 'Dit is geen geldig telefoonnummer'
    })
}

const install = function (Vue) {
  RegisterExtensions()

  Vue.component('ValidationProvider', ValidationProvider)
  setInteractionMode('eager')
}

export default { install }
